module.exports = __webpack_public_path__ + "static/img/Ajustados sin fondo_listo.aeb90842.svg";